module.exports = __webpack_public_path__ + "img/wqzk.fdbc09b7.png";